module.exports = __webpack_public_path__ + "static/media/frutiger-45light.d5f72416.eot";